import React from 'react';
import InfoIcon from "../../../icons/InfoIcon";
import hidePriceSkus from '../../../utils/hidePriceSkus';
import { isHR } from '../../../utils/isHr';
import { T } from '../../../utils/I18n/I18n';
import './PriceInfo.scss'

const LOWEST_PRICE_PREFIX = 'Najniža cijena zadnjih 30 dana';
const isLowestPrice = (description) => isHR && description.startsWith(LOWEST_PRICE_PREFIX);

export const LowestPriceInfo = ({product}) => {
    if (!product || hidePriceSkus.includes(product.sku)) {
        return null;
    }

    const lowestPrices = [...new Set((product.prices || []).flatMap((price) => price?.description || []).filter(isLowestPrice))];

    if (lowestPrices.length == 0) {
        return null;
    }

    return (
        <div className='lowest-price-info'>
            {lowestPrices.map((description, index) => (
                <div key={index}><T id="product.lowestPriceLabel"/>{description.slice(LOWEST_PRICE_PREFIX.length)}</div>
            ))}
        </div>
    )
}

const PriceInfo = ({product, ...props}) => {
    if (!product || hidePriceSkus.includes(product.sku)) {
        return null;
    }

    const infos = (product?.prices || [])
        .filter((price) => price?.description && Array.isArray(price.description))
        .map((price) => ({...price, description: price.description.filter((description) => !isLowestPrice(description))}))
        .filter((price) => price.description.length > 0);


    if (infos.length == 0) {
        return false;
    }

    return (
        <div className='price-info'>
            {
                infos.map((price, index) => {
                    return (
                        <div className='item' key={index}>
                            <div><InfoIcon className={'price_description_icon'} fill={price.bg_color}/></div>
                            <div className='infos'>
                                <span className='info_head' style={{}}>{price.label}</span>
                                {(price.description || []).map((description, index) => {
                                    return (
                                        <span key={index}>{description} </span>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })
            }
            {props.children}
        </div>
    )
}

export default PriceInfo